// Desc: Custom hook to determine the environment and return the appropriate URL
const useEnv = () => {
  const isDev = process.env.NODE_ENV === 'development';

  const envUrl = isDev 
    ? 'http://127.0.0.1:5001/joltchat/us-central1' 
    : 'https://us-central1-joltchat.cloudfunctions.net';

  return envUrl;
};

export default useEnv;